<div>
  @if (entity?.created_at) {
    <span>
      Created: <span class="ago">{{ moment.utc(entity.created_at).fromNow() }}</span>
    </span>
  }
  @if (entity?.created_at && entity?.updated_at) {
    <span> | </span>
  }
  @if (entity?.updated_at) {
    <span>
      Last Edited: <span class="ago">{{ moment.utc(entity.updated_at).fromNow() }}</span>
    </span>
  }
</div>
